<div class="card-body">
  <div class="row">
    <div class="col-auto">
      <div class="input-group input-group-sm">
        <input type="text" class="form-control" placeholder="검색어"
               [(ngModel)]="searchValue"
               (keyup.enter)="keyupEnterSearchValue($event)">
        <div class="input-group-append">
          <button type="button" class="btn btn-outline-secondary"
                  (click)="clickSearch()">
            <i class="fas fa-search"></i>
            <span class="ml-1">
              검색
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-auto">
      <select class="form-control form-control-sm"
              [(ngModel)]="selectedYear"
              (ngModelChange)="changeYear($event)">
        <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
      </select>
    </div>
    <div class="col-auto">
      <select class="form-control form-control-sm"
              [(ngModel)]="selectedMonth"
              (ngModelChange)="changeMonth($event)">
        <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
      </select>
    </div>
    <div class="col"></div>

    <div class="col-auto">
      <button type="button" class="btn btn-sm btn-info" (click)="clickSearch()">
        <i class="fas fa-sync mr-1"></i>
        불러오기
      </button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-sm btn-outline-success"
              (click)="excelDownload()">
        <i class="fas fa-file-excel"></i>
        <span class="ml-1">엑셀출력</span>
      </button>
    </div>
  </div>

  <div class="table-responsive mt-3">
    <table class="table table-sm table-bordered table-hover align-items-center mb-0 text-center text-nowrap">
      <thead>
        <tr class="text-center">
          <th>소속회사</th>
          <th>차량번호</th>
          <th>운행거리</th>
          <th>안전지수</th>
          <th>연료소모량</th>
          <th>탄소배출량(tC)</th>
        </tr>
        </thead>
        <tbody class="">
            <ng-container *ngIf="!listItem || listItem.length < 1">
            <tr class="text-center">
              <td colspan="13">
                표시 할 항목이 없습니다
              </td>
            </tr>
          </ng-container>
          <ng-container *ngFor="let item of listItem | sortBy:'desc':'pointSafe';let idx = index;">
            <tr>
              <td>
                {{item.companyNm}}
              </td>
              <td>
                {{item.dtgCarNo}}
              </td>
              <td>
                {{item.dtgDistAccumul | filterDist | number:'0.0-3'}}
              </td>
              <td>
                {{item.pointSafe | number: '0.0-1'}}
              </td>
              <td>
                {{item.dtgOilUseAccumul / 1000 | number: '0.0-1'}}
              </td>
              <td>
                {{item.carbonEmissions | number: '0.0-5'}}
              </td>
            </tr>
          </ng-container>
      </tbody>
    </table>
  </div>

  <div class="mt-3">
    <list-paging
      [inputPagingInfo]="pagingInfo"
      (callbackClickPageNumber)="callbackClickPageNumber($event)"
      (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
  </div>
</div>
